<script setup>
import { computed } from 'vue';
import { kebabCase } from 'lodash';

const props = defineProps({
  id: {
    type: String,
    default: null,
  },
  header: {
    type: String,
    required: true,
  },
  sub: Boolean,
});

const componentHeader = computed(() => {
  return props.sub ? 'h3' : 'h2';
});
const parsedId = computed(() => props.id || kebabCase(props.header));
</script>

<template>
  <component :is="componentHeader" :id="parsedId" :class="[componentHeader, sub ? 'ml-3' : '']">
    <span><a :href="`#${parsedId}`">#</a></span> {{ header }}
  </component>
</template>